export const manifestLocales = {
  embed: {
    previewImageAlt: {
      en: 'embed widget',
      he: 'פריט הטמעה'
    }
  }
};
